import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { notificationService } from '@/lib/services/notification.service';
import { logger } from '@/lib/utils/logger';
import { uninstallMcp, USER_MCP_QUERY_KEYS } from '../../api';

export const useUninstallMcp = () => {
  const { t } = useTranslation('admin');
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ mcpCatalogId }: { mcpCatalogId: string }) => uninstallMcp(mcpCatalogId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: USER_MCP_QUERY_KEYS.installed });
      // Deliberately do NOT refetch this MCP's health: the install is gone, so a /test would hit
      // the install gate (resolveServer → null) and 404. Reinstall re-checks via useInstallMcp.
      notificationService.showSuccess(t('userMcpServers.useUninstallMcp.mcpServerUninstalled'));
    },
    onError: (error) => {
      notificationService.showError(t('userMcpServers.useUninstallMcp.failedToUninstallMcpServer'));
      logger.error('Failed to uninstall MCP:', error);
    },
  });
};
